import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import * as _ from "lodash";
import { LocalDataSource } from "ng2-smart-table";
import { StbCustomRenderNumberComponent } from "../smart-table-customs/custom-render-number";
import { DialogProductInventoriesComponent } from "../dialog-product-inventories/dialog-product-inventories.component";
import Shop from "../../models/shop.model";

@Component({
  selector: "ngx-view-table-inventories",
  styleUrls: ["./view-table-inventories.component.scss"],
  templateUrl: "./view-table-inventories.component.html",
})
export class ViewTableInventoriesComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop;
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter();
  @Output() onChangeData: EventEmitter<any> = new EventEmitter();
  @Input() warningStock?: boolean = false;

  user?: User;

  loading = false;
  submitted = false;
  isEditing = false;

  strSearch = "";
  uid = "anonymous";

  //ng2-smart-table config
  @Input() source: LocalDataSource = new LocalDataSource();
  settings = {};

  constructor(
    private userService: UserService,
    private dialogService: NbDialogService,
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          this.settings = {
            hideHeader: false,
            noDataMessage:
              user.language == "en" ? "Empty data" : "Không có dữ liệu",
            attr: {
              class: "table table-striped",
            },
            // selectMode: "multi",
            pager: {
              display: true,
              perPage: 10,
            },
            actions: {
              columnTitle: "",
              add: false,
              edit: false,
              delete: false,
            },
            columns: {
              groupName: {
                title: "Ngành hàng",
                type: "string",
              },
              categoryName: {
                title: "Loại hàng",
                type: "string",
              },
              barcode: {
                title: user.language == "en" ? "Barcode" : "Mã hàng",
                type: "string",
              },
              title: {
                title: user.language == "en" ? "Product" : "Tên sản phẩm",
                type: "string",
              },
              unitName: {
                title: user.language == "en" ? "Unit" : "ĐVT",
                width: "100px",
                filter: false,
                type: "string",
              },
              price: {
                title: user.language == "en" ? "Price" : "Giá bán",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              // wsPrice: {
              //   title: user.language == "en" ? "WS Price" : "Giá sỉ",
              //   width: "100px",
              //   filter: false,
              //   type: "custom",
              //   renderComponent: StbCustomRenderNumberComponent,
              // },
              receiveQuantity: {
                title: user.language == "en" ? "Receive qty" : "SL Nhập",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              // receiveAmount: {
              //   title: user.language == "en" ? "Receive $" : "$ Nhập",
              //   width: "100px",
              //   filter: false,
              //   type: "custom",
              //   renderComponent: StbCustomRenderNumberComponent,
              // },
              issueQuantity: {
                title: user.language == "en" ? "Issue qty" : "SL Xuất",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              // issueAmount: {
              //   title: user.language == "en" ? "Issue $" : "$ Xuất",
              //   width: "100px",
              //   filter: false,
              //   type: "custom",
              //   renderComponent: StbCustomRenderNumberComponent,
              // },
              balanceQuantity: {
                title: user.language == "en" ? "Stock qty" : "SL Tồn",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              // balanceAmount: {
              //   title: user.language == "en" ? "Stock $" : "$ Tồn",
              //   width: "100px",
              //   filter: false,
              //   type: "custom",
              //   renderComponent: StbCustomRenderNumberComponent,
              // },
              warningStockMin: {
                title: user.language == "en" ? "Need receive" : "Cần nhập",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
              warningStockMax: {
                title: user.language == "en" ? "Need issue" : "Cần xuất",
                width: "100px",
                filter: false,
                type: "custom",
                renderComponent: StbCustomRenderNumberComponent,
              },
            },
          };

          if (!this.user.admin || !this.user.moderator) {
            delete this.settings["columns"]["receiveQuantity"];
            delete this.settings["columns"]["issueQuantity"];
          }

          if (!this.warningStock) {
            delete this.settings["columns"]["warningStockMin"];
            delete this.settings["columns"]["warningStockMax"];
          }

          if (!this.shop.trade) {
            delete this.settings["columns"]["wsPrice"];
          }
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectedProduct(event): void {
    const item = event.data;
    console.log("selectedProduct/selected:", item);

    // this.onSelectedItem.emit(item);

    this.dialogService
      .open(DialogProductInventoriesComponent, {
        context: {
          shopId: this.shopId,
          product: item,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value.hadChange) {
          this.onChangeData.emit(value);
        }
      });
  }
}
